import React from 'react';
import { Trophy, Star, Coins, Award } from 'lucide-react';

function ProfileSection() {
  const achievements = [
    { icon: Trophy, title: "Victory Master", description: "Won 100 matches" },
    { icon: Star, title: "Challenge Champion", description: "Completed 500 challenges" },
    { icon: Coins, title: "Credit King", description: "Earned 50,000 credits" },
    { icon: Award, title: "Elite Builder", description: "Built 10,000 structures" }
  ];

  return (
    <section className="py-16 px-4" id="profile">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12 bg-gradient-to-r from-[#0dceda] to-white text-transparent bg-clip-text">
          Your Profile
        </h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-2xl font-semibold mb-6">Stats Overview</h3>
            <div className="space-y-6">
              <div>
                <p className="text-gray-600">Total Credits Earned</p>
                <p className="text-3xl font-bold text-[#0dceda]">15,750</p>
              </div>
              <div>
                <p className="text-gray-600">V-Bucks Purchased</p>
                <p className="text-3xl font-bold text-[#0dceda]">3,800</p>
              </div>
              <div>
                <p className="text-gray-600">Challenges Completed</p>
                <p className="text-3xl font-bold text-[#0dceda]">127</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h3 className="text-2xl font-semibold mb-6">Achievements</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {achievements.map((achievement, index) => (
                <div key={index} className="flex items-start space-x-4 p-4 rounded-lg bg-gray-50">
                  <achievement.icon className="h-8 w-8 text-[#0dceda]" />
                  <div>
                    <h4 className="font-semibold">{achievement.title}</h4>
                    <p className="text-sm text-gray-600">{achievement.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfileSection;